module.exports = __webpack_public_path__ + "img/01 Aniamtion 3-squashed.4b337371.jpg";